import { Controller } from "@hotwired/stimulus"

// Base dates apply to every category. Extension dates remain specific to
// sub-categories and are cleared when no parent category is selected.
export default class extends Controller {
  static targets = [
    "parent", "baseStart", "baseEnd", "extensionFields",
    "extensionInput", "extensionStart", "extensionEnd", "rangeNote"
  ]

  static values = {
    projectStart: String,
    projectEnd: String,
    projectRangeText: String,
    parentRangeText: String
  }

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasParentTarget || !this.hasExtensionFieldsTarget) return

    const show = this.parentTarget.value !== ""
    this.extensionFieldsTarget.classList.toggle("hidden", !show)

    if (!show) {
      this.extensionInputTargets.forEach((element) => (element.value = ""))
    }

    const selectedParent = this.parentTarget.selectedOptions[0]
    const parentStart = selectedParent?.dataset.startDate
    const parentEnd = selectedParent?.dataset.endDate
    const useParentRange = show && parentStart && parentEnd

    this.rangeStart = useParentRange ? parentStart : this.projectStartValue
    this.rangeEnd = useParentRange ? parentEnd : this.projectEndValue
    this.updateDateBounds()
    this.updateRangeNote(useParentRange)
  }

  updateDateBounds() {
    if (this.hasBaseStartTarget) {
      this.baseStartTarget.min = this.rangeStart
      this.baseStartTarget.max = this.rangeEnd
    }

    if (this.hasBaseEndTarget) {
      this.baseEndTarget.min = (this.hasBaseStartTarget && this.baseStartTarget.value) || this.rangeStart
      this.baseEndTarget.max = this.rangeEnd
    }

    this.updateExtensionBounds()
  }

  updateExtensionBounds() {
    if (!this.rangeStart || !this.rangeEnd) return

    const extensionMin = this.nextDate(this.hasBaseEndTarget ? this.baseEndTarget.value : "") || this.rangeStart

    if (this.hasExtensionStartTarget) {
      this.extensionStartTarget.min = extensionMin
      this.extensionStartTarget.max = this.rangeEnd
    }

    if (this.hasExtensionEndTarget) {
      this.extensionEndTarget.min = (this.hasExtensionStartTarget && this.extensionStartTarget.value) || extensionMin
      this.extensionEndTarget.max = this.rangeEnd
    }
  }

  updateRangeNote(useParentRange) {
    if (!this.hasRangeNoteTarget) return

    const template = useParentRange ? this.parentRangeTextValue : this.projectRangeTextValue
    this.rangeNoteTarget.textContent = template
      .replace("__START__", this.rangeStart)
      .replace("__END__", this.rangeEnd)
  }

  nextDate(value) {
    if (!value) return null

    const date = new Date(`${value}T00:00:00Z`)
    date.setUTCDate(date.getUTCDate() + 1)
    return date.toISOString().slice(0, 10)
  }

}
